
<template>
  <div>
    <multiselect
      class="multiselect-performance"
      select-label=""
      deselect-label=""
      selected-label=""
      v-model="value"
      :options="options"
      :multiple="true"
      :close-on-select="false"
      :clear-on-select="false"
      :preserve-search="true"
      :placeholder="placeHolderMessage"
      label="title" track-by="key"
      :preselect-first="true"
    >
      <template slot="selection" slot-scope="{ values, isOpen }"><span class="multiselect__single" v-if="handleOpen(values, isOpen)">{{ values.length }} Itens Selecionados</span></template>
      <template slot="beforeList" slot-scope="">
        <div class="beforeList">
          <input :checked="isCheckedSelectAll" class="opt-checkbox" type="checkbox" @change="handleSelectAll" /> Selecionar Todos
        </div>
      </template>
      <template slot="tag" slot-scope="">{{''}}</template>
      <template #caret="{toggle}">
      <div>
        <div  @mousedown.prevent.stop="toggle" class="multiselect__select multiselect-toggle">
            <i class="h-icon-down" />
        </div>
      </div>
      </template>
      <template slot="noResult" slot-scope="">{{'Nada encontrado'}}</template>
      <template slot="noOptions" slot-scope="">{{'Nenhum resultado encontrado'}}</template>
      <template slot="option" slot-scope="props">
        <input class="opt-checkbox" type="checkbox" :checked="isChecked(props.option.key)" /> {{props.option.title}}
      </template>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
  components: { Multiselect },
  data() {
    return {
      value: []
    };
  },
  props: {
    valueProp: {
      type: [Array, String],
      required: true,
      default: () => []
    },
    options: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  computed: {
    placeHolderMessage() {
      const showQtd = this.value && this.value.length;

      return showQtd
        ? `${this.value.length} Itens Selecionados`
        : 'Selecione ...';
    },
    isCheckedSelectAll() {
      return this.value.length === this.options.length;
    }
  },
  methods: {
    isChecked(key) {
      return this.value.find(i => i.key === key);
    },
    handleSelectAll(value) {
      const isChecked = value.target.checked;

      isChecked
        ? this.value = this.options
        : this.value = [];
    },
    setInitialValue() {
      const hasValue = this.valueProp || [];
      const valuesSelected = hasValue.map(k => {
        return this.options.find(o => o.key === k);
      });
      this.value = valuesSelected;
    },
    handleOpen(values, isOpen) {
      return values.length && !isOpen;
    }
  },
  watch: {
    value(value) {
      this.$emit('updateValue', value);
    }
  },
  mounted() {
    this.setInitialValue();
  }
};
</script>
<style>

.multiselect-performance .multiselect__placeholder {
  display: inline-block !important;
  margin-bottom: 0px !important;
  padding-top: 0px !important;
}
.multiselect-performance .multiselect__input {
  border: none;
  display: block;
}
.multiselect-performance .multiselect__tags{
  padding: 7px 64px 0 8px;
  min-height: 35px
}
.multiselect-performance .multiselect__tags span:not(.multiselect__single, .multiselect__placeholder){
  background:#ff8000;
  max-height: 20px;
}
.multiselect-performance .multiselect__option--highlight {
  background: #ff8000;
}

.multiselect-performance .multiselect__tag-icon:focus,
.multiselect-performance .multiselect__tag-icon:hover {
  background: #ff8000;
}

.multiselect-performance  .opt-checkbox{
  transform: scale(1.2);
  filter: hue-rotate(178deg);
  cursor: pointer;
}
.multiselect-performance .beforeList{
  background: #f9f9f9;
  padding: 8px;
  font-size: 12px;

}
.multiselect-performance .multiselect__element{
  font-size: 12px;
}

.multiselect-toggle{
  font-size: 10px;
  color: #666666;
}
.multiselect-performance .multiselect__select{
  width: 30px;
}

.multiselect-performance .multiselect__select:before{
    border-style: none;
    display: flex;
    justify-content: center;
    align-items: center;
}

</style>
